import PropTypes from 'prop-types';

import CardInput from 'honeydew/CardInput';
import { trackEvent } from 'utils/analyticsUtils';

function AssortmentAisleCard({ aisle, currentAisle, setCurrentAisle }) {
    const isMango = window.location.pathname.includes('mango');

    return (
        <CardInput
            inputAttributes={{
                name: 'aisle',
                handleChange: () => {
                    setCurrentAisle(aisle.id);
                    trackEvent('grocery preview aisle clicked', {
                        location: isMango ? 'home page' : 'lead capture page',
                        aisle: aisle.name,
                    });
                    localStorage.setItem('assortmentModuleAisleId', aisle.id);
                },
            }}
            checked={currentAisle === aisle.id}
            key={aisle.id}
        >
            <div className="mx-auto flex w-max gap-10 px-5">
                <img src={aisle.icon} alt={aisle.name} className="h-30 w-30" />
                <p className="text-body-sm relative top-[2px] line-clamp-2 font-grotesk-bold">{aisle.name}</p>
            </div>
        </CardInput>
    );
}

AssortmentAisleCard.propTypes = {
    aisle: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    currentAisle: PropTypes.number.isRequired,
    setCurrentAisle: PropTypes.func.isRequired,
};

export default AssortmentAisleCard;
